import type { CityIncludesWithToken } from '@bond/bruce-api/api/location/city/response'
import { getCreditsDiscount } from './getCreditsDiscount'

export function getCreditsPrice(
  credits: number,
  city:
    | CityIncludesWithToken<{
        params: {
          include_country: true
          include_booking_methods: true
        }
      }>
    | undefined,
) {
  const creditsDiscount = getCreditsDiscount(credits, city)

  return (
    (city?.credit_price || 1000) *
    (1 - (creditsDiscount?.percent ? creditsDiscount.percent / 100 : 0)) *
    credits
  )
}
